import { render, staticRenderFns } from "./ImprotUserInfo.vue?vue&type=template&id=849cea3e&scoped=true&"
import script from "./ImprotUserInfo.vue?vue&type=script&lang=js&"
export * from "./ImprotUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./ImprotUserInfo.vue?vue&type=style&index=0&id=849cea3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849cea3e",
  null
  
)

export default component.exports